import { Link } from 'gatsby';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: inline-block;
  width: 100%;
`;

export const Scroller = styled.div`
  max-width: 100%;
  display: flex;
  overflow-y: auto;
  flex-wrap: nowrap;
  align-items: flex-start;
  justify-content: flex-start;
  position: relative;
  border-right: 1px solid ${({ theme }) => theme.palette.divider};
  border-left: 1px solid ${({ theme }) => theme.palette.divider};
`;

export const CardWrapper = styled.div`
  padding: 0 2px;
  display: inline-flex;
`;

export const ViewAll = styled(Link)`
  color: ${({ theme }) => theme.palette.info.main};
`;

export const HeaderSpacing = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;
